
import axios from 'axios';
import { Municipio } from '../types/ibge';

const ibgeApi = axios.create({
  baseURL: 'https://servicodados.ibge.gov.br/api/v1',
});


const ibgeApiV3 = axios.create({
  baseURL: 'https://servicodados.ibge.gov.br/api/v3',
});

const ibgeApiV4 = axios.create({
  baseURL: 'https://servicodados.ibge.gov.br/api/v4',
});


const datasusApi = axios.create({
  baseURL: 'https://datasus.damine.com.br/api',
});

export const getMunicipios = async (uf: string): Promise<Municipio[]> => {
  const response = await ibgeApi.get(`/localidades/estados/${uf}/municipios`);
  return response.data;
};

export const getUfMalha = async (uf: string) => {
  const response = await axios.get(`https://servicodados.ibge.gov.br/api/v3/malhas/estados/${uf}?formato=application/vnd.geo+json`);
  return response.data;
};

export const getMunicipioMalha = async (municipio: string) => {
  const response = await axios.get(`https://servicodados.ibge.gov.br/api/v3/malhas/municipios/${municipio}?formato=application/vnd.geo+json`);
  return response.data;
};

export const getDengueData = async (uf: string, year: number) => {
  const response = await datasusApi.get(`/dengue-data?ano=${year}&uf=${uf}`);
  return response.data;
};

export const getZikaData = async (uf: string, year: number) => {
  const response = await datasusApi.get(`/zika-data?ano=${year}&uf=${uf}`);
  return response.data;
};

export const getChikungunyaData = async (uf: string, year: number) => {
  const response = await datasusApi.get(`/chikungunya-data?ano=${year}&uf=${uf}`);
  return response.data;
};

export const getCnesData = async (uf: string, year: number, month: string) => {
  const response = await datasusApi.get(`/cnes-estabelecimentos?ano=${year}&mes=${month}&uf=${uf}`);
  return response.data;
};

export const getCnesPorNatureza = async (uf: string, year: number, month: string) => {
  const response = await datasusApi.get(`/cnes-por-natureza?ano=${year}&mes=${month}&uf=${uf}&natureza_ids=23`);
  return response.data;
};

export const getMunicipioInfo = async (municipio: string) => {
  const response = await ibgeApi.get(`/localidades/municipios/${municipio}`);
  return response.data;
};

export const getPopulationData = async (municipioId: string) => {
  const response = await ibgeApiV3.get(`agregados/9514/periodos/2022/variaveis/93?localidades=N6[${municipioId}]`);
  return response.data;
};

export const getMunicipioMetadata = async (municipioId: string) => {
  const response = await ibgeApiV4.get(`malhas/municipios/${municipioId}/metadados`);
  return response.data;
};

export const getCnesEquipes = async (uf: string, year: number, month: string) => {
  const response = await datasusApi.get(`/cnes-equipes?ano=${year}&mes=${month}&uf=${uf}&natureza_id=23`);
  return response.data;
};


